const CompanyActionTypes = {
  /*****************  GET COMPANY LIST START  *******************/
  GET_COMPANY_LIST_START: "get_company_list_start",
  GET_COMPANY_LIST_SUCCESS: "get_company_list_success",
  GET_COMPANY_LIST_FAILURE: "get_company_list_failure",
  GET_COMPANY_LIST_RESPONSE_RESET: "get_company_list_response_reset",
  GET_COMPANY_LIST_RESPONSE_CHANGED: "get_company_list_response_changed",
  /*****************  GET COMPANY LIST END  *******************/

  /*****************  ADD COMPANY DETAILS START  *******************/
  ADD_COMPANY_DETAILS_START: "add_company_details_start",
  ADD_COMPANY_DETAILS_SUCCESS: "add_company_details_success",
  ADD_COMPANY_DETAILS_FAILURE: "add_company_details_failure",
  ADD_COMPANY_DETAILS_RESPONSE_RESET: "add_company_details_response_reset",
  ADD_COMPANY_DETAILS_RESPONSE_CHANGED: "add_company_details_response_changed",
  /*****************  ADD COMPANY DETAILS END  *******************/

  /*****************  UPDATE COMPANY DETAILS START  *******************/
  UPDATE_COMPANY_DETAILS_START: "update_company_details_start",
  UPDATE_COMPANY_DETAILS_SUCCESS: "update_company_details_success",
  UPDATE_COMPANY_DETAILS_FAILURE: "update_company_details_failure",
  UPDATE_COMPANY_DETAILS_RESPONSE_RESET:
    "update_company_details_response_reset",
  UPDATE_COMPANY_DETAILS_RESPONSE_CHANGED:
    "update_company_details_response_changed",
  /*****************  UPDATE COMPANY DETAILS END  *******************/

  /*****************  DELETE COMPANY DETAILS START  *******************/
  DELETE_COMPANY_DETAILS_START: "delete_company_details_start",
  DELETE_COMPANY_DETAILS_SUCCESS: "delete_company_details_success",
  DELETE_COMPANY_DETAILS_FAILURE: "delete_company_details_failure",
  DELETE_COMPANY_DETAILS_RESPONSE_RESET:
    "delete_company_details_response_reset",
  DELETE_COMPANY_DETAILS_RESPONSE_CHANGED:
    "delete_company_details_response_changed",
  /*****************  DELETE COMPANY DETAILS END  *******************/

  /*****************  FETCH COMPANY DETAILS START  *******************/
  FETCH_COMPANY_DETAILS_START: "fetch_company_details_start",
  FETCH_COMPANY_DETAILS_SUCCESS: "fetch_company_details_success",
  FETCH_COMPANY_DETAILS_FAILURE: "fetch_company_details_failure",
  FETCH_COMPANY_DETAILS_RESPONSE_RESET: "fetch_company_details_response_reset",
  FETCH_COMPANY_DETAILS_RESPONSE_CHANGED:
    "fetch_company_details_response_changed",
  /*****************  FETCH COMPANY DETAILS END  *******************/

  /** ***************** ADD INSTANCE DETAILS START *********************** */
  ADD_INSTANCE_DETAILS_START: "add_instance_details_start",
  ADD_INSTANCE_DETAILS_SUCCESS: "add_instance_details_success",
  ADD_INSTANCE_DETAILS_FAILURE: "add_instance_details_failure",
  ADD_INSTANCE_DETAILS_RESPONSE_RESET: "add_instance_details_response_reset",
  ADD_INSTANCE_DETAILS_RESPONSE_CHANGED:
    "add_instance_details_response_changed",
  /** ************** ADD INSTANCE DETAILS END *********************** */
};
export default CompanyActionTypes;
